import { Ripple } from "../ripple/ripple2.js";
import { Symbol } from "../symbol/symbol2.js";
import { TextInputType } from "./text-input-type.js";
import { TextInput } from "./text-input2.js";
import { TextInputHelperText } from "./text-input-helper-text2.js";
import { TextInputLabel } from "./text-input-label2.js";
import { TextInputContainer } from "./text-input-container2.js";
import { TextInputErrorMessage } from "./text-input-error-message2.js";
import { TextInputIcon } from "./text-input-icon2.js";
import { TextInputLayout } from "./text-input-layout2.js";
import { TextInputPrefix } from "./text-input-prefix2.js";
import { TextInputCurrency } from "./text-input-currency.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-wrapper.tsx
var TextInputWrapper = forwardRef(({ hasError, label, layoutClassName, value, isDisabled, isLayoutDisabled, onChange, onBlur, onContainerClick, onTextInputIconClick, textInputIcon, textInputIconVariation, currency, inputType, inputMode, maxLength, errorMessage, placeHolder, bottomHelperText, textInputPrefix, max, min }, ref) => {
	const isDate = inputType === TextInputType.DATE;
	return /* @__PURE__ */ jsxs(TextInputLayout, {
		hasError,
		className: layoutClassName,
		isDisabled: isLayoutDisabled,
		children: [
			/* @__PURE__ */ jsx(TextInputLabel, { children: label }),
			/* @__PURE__ */ jsxs(TextInputContainer, {
				className: classNames({ "is-date": isDate }),
				onClick: isDate ? void 0 : onContainerClick,
				children: [
					textInputPrefix && /* @__PURE__ */ jsx(TextInputPrefix, { children: textInputPrefix }),
					/* @__PURE__ */ jsx(TextInputCurrency, { children: currency }),
					/* @__PURE__ */ jsx(TextInput, {
						ref,
						max,
						min,
						placeHolder,
						value: String(value),
						isDisabled,
						inputType,
						inputMode,
						maxLength,
						onChange,
						onBlur
					}),
					textInputIcon && /* @__PURE__ */ jsxs(TextInputIcon, { children: [onTextInputIconClick && /* @__PURE__ */ jsx(Ripple, {
						onClick: onTextInputIconClick,
						children: /* @__PURE__ */ jsx(Symbol, {
							symbol: textInputIcon,
							variation: textInputIconVariation
						})
					}), !onTextInputIconClick && /* @__PURE__ */ jsx(Symbol, {
						symbol: textInputIcon,
						variation: textInputIconVariation
					})] })
				]
			}),
			bottomHelperText && /* @__PURE__ */ jsx(TextInputHelperText, { children: bottomHelperText }),
			errorMessage && /* @__PURE__ */ jsx(TextInputErrorMessage, { children: errorMessage })
		]
	});
});
//#endregion
export { TextInputWrapper };

//# sourceMappingURL=text-input-wrapper.js.map